import { styled } from 'leva/plugin'

export const StyledMainContainer = styled('div', {
    MozUserSelect: 'none', 
    WebkitUserSelect: 'none', 
    msUserSelect: 'none', 
    height:'100vh',
    overflow: 'hidden',
    width:'100vw',
    alignItems:'stretch', 
    display:'flex', 
    '  > div > div > div > div': {
        paddingTop: '0px !important',
        paddingBottom: '0px !important',
        height:'100vh', 
        display: 'flex',
        flexDirection: 'column',
    }
})
